import React from 'react';

const PaymentSummary = (props) => {
    console.log(props.invoiceDetails.subTotal)
    return (
        <div className="item-sections  min-w-[280px] max-w-[300px]   p-3 rounded-[10px] " style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "rgb(245 245 245)" }}>
            <p className='text-center font-semibold'>Summary</p>
            <div className="search-grp flex gap-2">
                <div className="w-[40%] flex items-center text-[14px] font-medium text-[#585858] pt-[8px] ">
                    SUB Total
                </div>
                <input
                    className="inputFocus w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                    type="number"
                    id="subTotal"
                    name="subTotal"
                    autocomplete="off"
                    disabled
                    value={props.invoiceDetails.subTotal}
                    onChange={(event) =>
                        this.handleChange(event, "subTotal", "invoiceDetails")
                    }
                />
            </div>
            {props.page !== 'InvoiceRM' && props.page !== 'InvoicePM' ?
                <div className="search-grp flex gap-2">
                    <div className="w-[40%] flex items-center text-[14px] font-medium text-[#585858] pt-[8px] ">
                        Discount
                    </div>
                    <input
                        className="inputFocus w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                        type="number"
                        id="discount"
                        name="discount"
                        autocomplete="off"
                        disabled
                        value={props.invoiceDetails.discount}
                        onChange={(event) =>
                            this.handleChange(event, "discount", "invoiceDetails")
                        }
                    />
                </div>
                : null}
            <div className="search-grp flex gap-2">
                <div className="w-[40%] flex items-center text-[14px] font-medium text-[#585858] pt-[8px] ">
                    SGST
                </div>
                <input
                    className="inputFocus w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                    type="number"
                    id="sgst"
                    name="sgst"
                    autocomplete="off"
                    disabled
                    value={props.invoiceDetails.sgst}
                    onChange={(event) =>
                        this.handleChange(event, "sgst", "invoiceDetails")
                    }
                />
            </div>

            <div className="search-grp flex gap-2">
                <div className="w-[40%] flex items-center text-[14px] font-medium text-[#585858] pt-[8px] ">
                    CGST
                </div>
                <input
                    className="inputFocus w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                    type="number"
                    id="cgst"
                    name="cgst"
                    autocomplete="off"
                    disabled
                    value={props.invoiceDetails.cgst}
                    onChange={(event) =>
                        this.handleChange(event, "cgst", "invoiceDetails")
                    }
                />
            </div>

            <div className="search-grp flex gap-2">
                <div className="w-[40%] flex items-center text-[14px] font-medium text-[#585858] pt-[8px] ">
                    IGST
                </div>
                <input
                    className="inputFocus w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                    type="number"
                    id="igst"
                    name="igst"
                    autocomplete="off"
                    disabled
                    value={props.invoiceDetails.igst}
                    onChange={(event) =>
                        this.handleChange(event, "igst", "invoiceDetails")
                    }
                />
            </div>

            {/* <div className="search-grp flex gap-2">
                <div className="w-[40%] flex items-center text-[14px] font-medium text-[#585858] pt-[8px] ">
                    UGST
                </div>
                <input 
                    className="inputFocus w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                    type="number"
                    id="ugst"
                    name="ugst"
                    autocomplete="off"
                    disabled
                    value={props.invoiceDetails.ugst}
                    onChange={(event) =>
                        this.handleChange(event, "ugst", "invoiceDetails")
                    }
                />
            </div>  */}

            <div className="search-grp flex gap-2">
                <div className="w-[40%] flex items-center text-[14px] font-medium text-[#585858] pt-[8px] ">
                    CR/DR Note
                </div>
                <input
                    className="inputFocus w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                    type="number"
                    id="crDrNote"
                    name="crDrNote"
                    autocomplete="off"
                    disabled
                    value={props.invoiceDetails.crDrNote}
                    onChange={(event) =>
                        this.handleChange(event, "crDrNote", "invoiceDetails")
                    }
                />
            </div>

            <div className="search-grp flex gap-2.5 mt-[10px]">
                <div className="w-[40%] flex items-center text-[14px] font-medium text-[#585858]">
                    Grand Total
                </div>
                <input
                    className="inputFocus w-[60%]"
                    type="number"
                    id="grandTotal"
                    name="grandTotal"
                    autocomplete="off"
                    disabled
                    value={props.invoiceDetails.grandTotal}
                    onChange={(event) =>
                        this.handleChange(event, "grandTotal", "invoiceDetails")
                    }
                />
            </div>
        </div>
    );
};

export default PaymentSummary;